var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconRsu = function SvgIconRsu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 4.006H2v5m12-5h16v18h-5m-11-18v5m0 13h-2m2 0v-13m0 13h3v4m-13 0v-4H2v-13m0 0h12",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgIconRsu as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzMiIHZpZXdCb3g9IjAgMCAzMiAzMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE0IDQuMDA1ODZIMlY5LjAwNTg2TTE0IDQuMDA1ODZIMzBWMjIuMDA1OUgyNU0xNCA0LjAwNTg2VjkuMDA1ODZNMTQgMjIuMDA1OUgxMk0xNCAyMi4wMDU5VjkuMDA1ODZNMTQgMjIuMDA1OUgxN1YyNi4wMDU5TTQgMjYuMDA1OVYyMi4wMDU5SDJWOS4wMDU4Nk0yIDkuMDA1ODZIMTQiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjEuOCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";